<template>
  <div>
    <div class="my-container">
      <h2>Cancer specificity analysis</h2>
      <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
<!--        <h3>Cancer specificity analysis</h3>-->
        <p style="text-align: justify;width: 90%;word-spacing: 5px;line-height: 25px;color: black">
          In cancer research, estimating cell malignancy and distinguishing malignant and non-malignant cells is also a critical issue. Generally, copy number alterations (CNV) inferred from SRT data are potential to identify malignant tumor cells, which was widely used in the research of various cancer types. CancerSRT enables users to infer CNV through InferCNV, copyKat and STARCH, and further differentiate between normal cells and tumor cells.
          In CancerSRT, we used 14 cancer functional states defined by CancerSEA and their gene signatures (including stemness, invasion, metastasis, proliferation, EMT, angiogenesis, apoptosis, cell cycle, differentiation, DNA damage, DNA repair, hypoxia,  inflammation and quiescence)to estimate variation scores of the known gene set activities over the spots via gene set variation analysis (GSVA), which was widely used to analyze signatures on various cancer types.
        </p>
        <hr style="width: 90%;margin-top: 30px;margin-bottom: 30px"/>
        <a style="text-align: left;word-spacing: 5px;line-height: 25px;width: 90%; text-decoration: underline;font-size: 20px" v-on:click="goToInferCNV">
          <b>
            1. Click to Cell Malignancy Estimation
          </b>
        </a>
        <div  class="my-div-center" v-on:click="goToInferCNV">
<!--          <img src="../assets/cancerExplorer/state.png" width="90%"  alt="pic load error">-->
          <img src="../../assets/cancerExplorer/inferCNV.jpg" width="90%" alt="pic load error">
        </div>
        <hr style="width: 90%;margin-top: 30px;margin-bottom: 30px"/>
        <a style="text-align: left;word-spacing: 5px;line-height: 25px;width: 90%; text-decoration: underline;font-size: 20px" v-on:click="goToState">
          <b>
            2. Click to Cell Functional States Exploration
          </b>
        </a>

        <div  class="my-div-center" v-on:click="goToState">
          <img src="../../assets/cancerExplorer/state.png" width="90%" alt="pic load error">
<!--          <img src="../assets/cancerExplorer/inferCNV1.png" width="90%" alt="pic load error">-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Explorer",
  methods: {
    goToInferCNV(){
      this.$router.push('/InferCNV')
    },
    goToState(){
      this.$router.push('/State')
    }
  }
}
</script>

<style scoped>
.my-div-center{
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
a{
  cursor: pointer;
}

</style>
